import React from 'react';

import { Paper } from 'material-ui';
import { Container, Row, Col } from 'reactstrap';

export default () => (
  <Container className="big_pt-30">
    <Row>
      <Col md={{ size: 6, offset: 3 }}>
        <Paper className="container">
          <h1 className="titleBlack">Cargando el sistema...</h1>
          <Row className="big_pt-30" />
        </Paper>
      </Col>
    </Row>
  </Container>
);



// WEBPACK FOOTER //
// src/modules/general/components/loadingScreen.js